// Detect auth callback payloads on public routes so we can hand them into /auth/callback.
function readParams(raw: string): URLSearchParams {
  if (!raw) {
    return new URLSearchParams();
  }

  return new URLSearchParams(raw.startsWith('#') ? raw.slice(1) : raw.startsWith('?') ? raw.slice(1) : raw);
}

function hasSearchCallbackPayload(search: string): boolean {
  const params = readParams(search);
  return Boolean(
    (params.get('token_hash') && params.get('type')) ||
    params.get('code') ||
    params.get('error_description'),
  );
}

function hasHashCallbackPayload(hash: string): boolean {
  const params = readParams(hash);
  return Boolean(
    params.get('access_token') ||
    params.get('refresh_token') ||
    params.get('type') ||
    params.get('error_description'),
  );
}

export function shouldHandoffPublicAuthCallback(input: {
  pathname: string;
  search: string;
  hash: string;
}): boolean {
  if (input.pathname === '/auth/callback') {
    return false;
  }

  return hasSearchCallbackPayload(input.search) || hasHashCallbackPayload(input.hash);
}

